module.exports = __webpack_public_path__ + "static/media/loading.34cf5337.gif";